import { useMutation } from '@tanstack/react-query'
import { downloadDistributionPlanPreviewReport } from './requests'

type UseDownloadDistributionPlanPreviewReportOptions = {
  onSuccess?: (blob: Blob) => void
  onError?: (error: Error) => void
}

export const useDownloadDistributionPlanPreviewReport = (
  options?: UseDownloadDistributionPlanPreviewReportOptions
) => {
  return useMutation({
    mutationFn: downloadDistributionPlanPreviewReport,
    onSuccess: (blob) => {
      options?.onSuccess?.(blob)
    },
    onError: (error: Error) => {
      options?.onError?.(error)
    },
  })
}
